import { useContext, createContext } from 'react';
var InputWrapperContext = createContext({
  offsetBottom: false,
  offsetTop: false,
  describedBy: void 0
});
var InputWrapperProvider = InputWrapperContext.Provider;

var useInputWrapperContext = function useInputWrapperContext() {
  return useContext(InputWrapperContext);
};

export { InputWrapperProvider, useInputWrapperContext };